import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { postData, pathData, deleteData } from "../../Utils/Http/api";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

// Configuraciones Casos Cualitativos → Estados de la Gestión (tabla propia, sin etapas).
function CasoCualitativoEstadoListar() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [descripcion, setDescripcion] = useState("");
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await postData('/CasoCualitativoEstadoListar', {});
            const list = res?.value || [];
            const data = list.map(item => {
                const canModify = item.sistema !== 1;

                const detalle = (
                    <MDBox>
                        <MDTypography variant="h6" color="text" fontWeight="medium">
                            {item.descripcion}
                        </MDTypography>
                        {!canModify && (
                            <MDTypography variant="caption" color="info" fontWeight="medium">
                                Estado de sistema
                            </MDTypography>
                        )}
                    </MDBox>
                );
                const action = (
                    <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                        {canModify && (
                            <>
                                <IconButton size="small" onClick={() => handleOpenEdit(item)} aria-label="editar">
                                    <EditIcon color="info" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={() => { setDeleteId(item.idCasoEstado); setOpenDelete(true); }}
                                    aria-label="eliminar"
                                >
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </>
                        )}
                    </MDBox>
                );
                return { id: item.idCasoEstado, detalle, action };
            });

            setRows(data);
            setColumns([
                { Header: 'Estado', accessor: 'detalle', align: 'left', width: '80%' },
                { Header: 'Acciones', accessor: 'action', align: 'center', width: '20%' }
            ]);
        } catch (ex) {
            console.error('Error cargando estados', ex);
            setSnackbar({ open: true, msg: 'Error al cargar los estados', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey]);

    const handleOpenAdd = () => {
        setEditMode(false);
        setCurrentItem(null);
        setDescripcion("");
        setOpenDialog(true);
    };

    const handleOpenEdit = (item) => {
        setEditMode(true);
        setCurrentItem(item);
        setDescripcion(item.descripcion || "");
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setCurrentItem(null);
        setDescripcion("");
    };

    const handleSave = async () => {
        if (!descripcion.trim()) {
            setSnackbar({ open: true, msg: 'La descripción es requerida', severity: 'warning' });
            return;
        }
        try {
            const res = editMode
                ? await pathData(`/CasoCualitativoEstadoUpdate/${currentItem.idCasoEstado}`, { descripcion })
                : await postData('/CasoCualitativoEstadoRegistrar', { descripcion });
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: editMode ? 'Estado actualizado correctamente' : 'Estado creado correctamente', severity: 'success' });
                handleCloseDialog();
                setRefreshKey(prev => prev + 1);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error guardando estado', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error guardando estado', ex);
            setSnackbar({ open: true, msg: ex?.detail || ex?.message || 'Error guardando estado', severity: 'error' });
        }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    const handleCancelDelete = () => {
        setDeleteId(null);
        setOpenDelete(false);
    };

    const handleConfirmDelete = async () => {
        if (!deleteId) return;
        try {
            const res = await deleteData(`/CasoCualitativoEstadoDelete/${deleteId}`);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Estado eliminado correctamente', severity: 'success' });
                setOpenDelete(false);
                setDeleteId(null);
                setRefreshKey(prev => prev + 1);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error eliminando estado', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error eliminando estado', ex);
            setSnackbar({ open: true, msg: ex?.detail || ex?.message || 'Error eliminando estado', severity: 'error' });
            setOpenDelete(false);
            setDeleteId(null);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="secondary"
                                borderRadius="lg"
                                coloredShadow="secondary"
                            >
                                <MDTypography variant="h6" color="white">
                                    Estados de Caso Cualitativo
                                </MDTypography>
                            </MDBox>

                            <MDBox pt={3} py={3} px={2}>
                                <MDBox mb={2} display="flex" gap={1}>
                                    <MDButton onClick={handleOpenAdd} variant="gradient" color="success" startIcon={<AddIcon />}>
                                        Agregar Estado
                                    </MDButton>
                                    <MDButton onClick={() => setRefreshKey(prev => prev + 1)} variant="outlined" color="info" startIcon={<SearchIcon />}>
                                        Buscar
                                    </MDButton>
                                </MDBox>

                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                        <CircularProgress />
                                    </MDBox>
                                ) : (
                                    <DataTable
                                        key={refreshKey}
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        showTotalEntries
                                        canSearch={false}
                                        noEndBorder
                                        pagination={{ color: 'warning', variant: 'gradient' }}
                                    />
                                )}

                                <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                                    <DialogTitle>{editMode ? 'Editar Estado' : 'Agregar Estado'}</DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <TextField
                                                label="Descripción *"
                                                value={descripcion}
                                                onChange={(e) => setDescripcion(e.target.value)}
                                                inputProps={{ maxLength: 150 }}
                                                fullWidth
                                                required
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCloseDialog}>Cancelar</MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSave}>Guardar</MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth maxWidth="xs">
                                    <DialogTitle>Eliminar Estado</DialogTitle>
                                    <DialogContent>
                                        <MDBox>
                                            <MDTypography>¿Confirma que desea eliminar este estado?</MDTypography>
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCancelDelete}>Cancelar</MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleConfirmDelete}>Eliminar</MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                                        {snackbar.msg}
                                    </MuiAlert>
                                </Snackbar>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default CasoCualitativoEstadoListar;
